module.exports = __webpack_public_path__ + "image/leaf_img4.png";